<template>
  <sc-table
    :data="data"
    :bordered="true"
    :paginated="data.length > perPage"
    :per-page="perPage">
    <template slot-scope="props">
      <sc-table-column
        field="id"
        label="ID"
        sortable>
        {{ props.row.id }}
      </sc-table-column>
      <sc-table-column
        field="weight"
        label="Peso"
        sortable>
        {{ props.row.weight }}
      </sc-table-column>
      <sc-table-column
        field="squared_weight"
        label="Peso cubado"
        sortable>
        {{ props.row.squared_weight }}
      </sc-table-column>
      <sc-table-column
        field="selected_weight"
        label="Peso selecionado"
        sortable>
        {{ props.row.selected_weight }}
      </sc-table-column>
      <sc-table-column
        field="tracking_code"
        label="Código de rastreio"
        sortable>
        {{ props.row.tracking_code }}
      </sc-table-column>
      <sc-table-column
        field="dimensions"
        label="Dimensões"
        sortable>
        {{ transformDimensions(props.row.dimensions) }}
      </sc-table-column>
    </template>
  </sc-table>
</template>

<script>
import {
  ScTable,
  ScTableColumn,
} from '@intelipost-js/secure-components';

export default {
  name: 'sc-pre-invoice-detail-volumes-table',
  props: {
    data: {
      type: Array,
      required: true,
    },
    perPage: {
      default: 10,
      type: Number,
    },
  },
  components: {
    ScTable,
    ScTableColumn,
  },
  methods: {
    transformDimensions(dimensions) {
      const { width, height, length } = dimensions || {};

      const dimensionsList = [width, height, length]
        .filter(item => !!item && typeof item === 'number')
        .map(item => `${item}cm`);

      return dimensionsList.join(' x ');
    },
  },
  mounted() {
    console.log('data: ', this.data); //eslint-disable-line
  },
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/pre-invoice-detail/components/sc-pre-invoice-detail-values/components/ScPreInvoiceDetailVolumesTable.vue